import { Exclude, Expose, Type } from 'class-transformer';
import moment, { Moment } from 'moment';
import { TwitterAccountDTO } from './twitter-account.dto';

export enum AccountType {
  INSTAGRAM = 'instagram',
  PINTEREST = 'pinterest',
  TIKTOK = 'tiktok'
}

export enum InstagramAccountType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',
  CREATOR = 'CREATOR',
  IG_BUSINESS = 'IG_BUSINESS',
  IG_CREATOR = 'IG_CREATOR'
}

export enum LinkAccountFlowType {
  ONBOARDING = 'onboarding',
  ADD_ACCOUNT = 'addAccount',
  TAKEOVER_ACCOUNT = 'takeoverAccount'
}

export enum LinkAccountType {
  NEW = 'new',
  EXISTING = 'existing',
  TAKEOVER_BY_USER = 'takeoverByUser',
  TAKEOVER_BY_CONTACT = 'takeoverByContact'
}

@Exclude()
export class AccountDTO {
  @Expose()
  @Type(() => String)
  id: string;

  @Expose()
  username: string;

  @Expose()
  pic: string;

  @Expose()
  type: AccountType;

  @Expose()
  isActive: boolean;

  @Expose()
  isDummy: boolean;

  @Expose()
  isOwner: boolean;

  @Expose()
  isShoplink: boolean;

  @Expose()
  isAutoPostEnabled: boolean;

  @Expose()
  isPersonal: boolean;

  @Expose()
  isPrimary: boolean;

  @Expose()
  isBusiness: boolean;

  @Expose()
  isCreator: boolean;

  @Expose()
  isFacebookAutoPostEnabled: boolean;

  @Expose()
  isTwitterAutoPostEnabled: boolean;

  @Expose()
  isValidFacebookToken: boolean;

  @Expose()
  isValidTwitterToken: boolean;

  @Expose()
  isPlatform: boolean;

  @Expose()
  accountType: InstagramAccountType;

  @Expose()
  token: string;

  @Expose()
  tokenExpiredAt: Moment;

  @Expose()
  @Type(() => TwitterAccountDTO)
  twitterAccount: TwitterAccountDTO;

  get isInstagram(): boolean {
    return this.type === AccountType.INSTAGRAM;
  }

  get isPinterest(): boolean {
    return this.type === AccountType.PINTEREST;
  }

  get isTiktok(): boolean {
    return this.type === AccountType.TIKTOK;
  }

  get canActivateAutoPost(): boolean {
    return (
      this.isInstagram && (this.isPersonal || this.accountType === InstagramAccountType.CREATOR)
    );
  }

  get canEnableAutoPost(): boolean {
    return this.isInstagram && this.isBusiness && this.isValidFacebookToken && !this.isPersonal;
  }

  get requiresAuthorization(): boolean {
    return this.isInstagram && this.isBusiness && !this.isValidFacebookToken;
  }
}
